import React from 'react';
import Navbar from '../Home/Navbar/Navbar';
import Footer from '../Home/Footer/Footer';
import './Experience.css';
import ExpHero from './ExpHero/ExpHero';
import ExpCard from './ExpCard/ExpCard';

import feature_1 from '../../Asset/experience/feature_1.png'
import feature_2 from '../../Asset/experience/feature_2.png'
import feature_3 from '../../Asset/experience/feature_3.png'

const Experience = () => {
    return (
        <div>
            <Navbar/>
            <ExpHero/>
            <ExpCard img={feature_1} />
            <ExpCard img={feature_2} />
            <ExpCard img={feature_3} />
            <Footer/>
        </div>
    );
};

export default Experience;